import { render } from "./LandingGlobalWarmingGlacialMeal.vue?vue&type=template&id=072e35df"
import script from "./LandingGlobalWarmingGlacialMeal.vue?vue&type=script&lang=js"
export * from "./LandingGlobalWarmingGlacialMeal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__